import {Empty, Input, Spin, Table, Tag} from 'antd';
import {debounce} from 'lodash';
import {useEffect, useMemo, useState} from 'react';
import DateObject from 'react-date-object';
import {useSelector} from 'react-redux';

import {RQGetAllUserOrderList} from '../../../../reactQuery/apis';
import {selectAuth} from '../../../../redux/selectors';

const columns = [
  {
    title: 'Sr. No.',
    key: 'index',
    render: (_, __, index) => index + 1,
    fixed: 'left',
    width:40,
  },
  {
    title: 'Product Image',
    dataIndex: 'imageUrl',
    key: 'imageUrl',

    render: url =>
      url ? (
        <img
          src={url}
          alt={'Product'}
          style={{
            width: 60,
            height: 60,
            objectFit: 'cover',
            borderRadius: 4,
            border: '1px solid #ddd',
          }}
        />
      ) : (
        <Tag color={'default'}>No Image</Tag>
      ),
  },
  {
    title: 'Product Name', dataIndex: 'productName', key: 'ProductName',

    fixed: 'left',
  },
  {
    title: 'Product Type', dataIndex: 'productType', key: 'productType',

    fixed: 'left',
  },
  {
    title: 'Jewelry Type', dataIndex: 'jewelryType', key: 'jewelryType',

    fixed: 'left',
  },
  {
    title: 'Qauntity', dataIndex: 'productQuantity', key: 'productQuantity',

    fixed: 'left',
  },
  {
    title: 'weight', dataIndex: 'weight', key: 'weight',
    fixed: 'left',
  },
  {
    title: 'Price Per Unit', dataIndex: 'pricePerUnit', key: 'pricePerUnit',

    fixed: 'left',
  },
  {
    title: 'Gift',
    dataIndex: 'gift',
    key: 'gift',
    render: gift =>
      gift === true ? (
        <p>🎁</p>
      ) : (
        <p>-</p>
      ),

  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',

    render: status => {

      const statusColors = {
        CONFIRMED: 'green',
        PENDING: 'orange',
        CANCELLED: 'red',
        SHIPPED: 'purple',
        DELIVERED: 'cyan',
      };

      return (
        <Tag color={statusColors[status] || 'default'}>
          {status}
        </Tag>
      );

    },
  },
  {
    title: 'Date', dataIndex: 'date', key: 'date',
    width: 100,
    fixed: 'left',
    sorter: (a, b) => a.dateSortValue - b.dateSortValue,
    sortDirections: ['ascend', 'descend'],
  },
];

// eslint-disable-next-line react/prop-types
const OrderSummary = ({userId}) => {
  const [searchText, setSearchText] = useState('');

  const [filteredData, setFilteredData] = useState([]);

  const [users, setUsers] = useState([]);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const {data: userData, isLoading, error} = RQGetAllUserOrderList(userId, token);

  const debounceSearch = useMemo(() =>
    debounce(value => {
      const searchableFields = ['name', 'status', 'price', 'category'];
      const filtered = users.filter(item =>
        searchableFields.some(field =>
          item[field]?.toLowerCase().includes(value.toLowerCase()),
        ),
      );
      setFilteredData(filtered);
    }, 300), [users]);

  const handleSearch = e => {
    const value = e.target.value;
    setSearchText(value);
    debounceSearch(value);
  };

  useEffect(() => {
    if (userData && userData.length > 0) {
      const formatted = userData.flatMap((order, orderIndex) => {
        return order.products.map((product, productIndex) => {
          const rawDate = order.createdOn;
          const dateObj = rawDate ? new DateObject({date: rawDate}) : null;
          const formattedDate = dateObj ? dateObj.format('DD-MM-YYYY') : 'N/A';

          return {
            key: `${order.id}-${product.productId}`,
            productName: product.productInfo?.productName || 'Unknown',
            productType: product.productType || 'Unknown',
            jewelryType: product.jewelryType || 'Unknown',
            category: product.productInfo?.category || 'N/A',
            imageUrl: product.productInfo?.imageUrl?.[0] || '',
            productQuantity: product.quantity || 'N/A',
            pricePerUnit: product.pricePerUnit || 'N/A',
            gift: product.gift || 'N/A',
            weight: product.weight || 'N/A',
            status: order.status || 'UNKNOWN',
            date: formattedDate,
            dateSortValue: dateObj?.toDate()?.getTime() || 0,
            id: order.id,
          };
        });
      });

      setUsers(formatted);
      setFilteredData(formatted);
    } else {
      console.log('No orders found');
    }
  }, [userData]);

  if (isLoading) { return <Spin size={'large'} />; }

  if (userData && userData.length === 0) {
    return (
      <div className={'p-6'}>
        <h2 className={'font-bold my-2'}>Order history</h2>
        <Empty description={'Not bought anything'} />
      </div>
    );
  }

  return (
    <div className={'py-6 px-3'}>
      <h2 className={'font-bold my-2'}>Order history</h2>
      <Input
        placeholder={'Search orders...'}
        value={searchText}
        onChange={handleSearch}
        style={{marginBottom: 16, width: 150}}
        allowClear
      />
      <Table
        tableLayout={'fixed'}
        size={'middle'}
        columns={columns}
        dataSource={filteredData}
        rowKey={'key'}
        scroll={{x: 'max-content'}}
        pagination={{pageSize: 10}}
      />
    </div>
  );
};

export default OrderSummary;
